var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"board"},_vm._l((_vm.pokemons),function(pokemon,index){return _c('Card',{key:((pokemon.id) + "-" + index),attrs:{"pokemon":pokemon,"data-component":pokemon.componentMatch},on:{"not-matched":_vm.notMatched}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }